import Vue from 'vue';
import { BfButton, BfModal, BfDialog } from 'components/Butterfly';
export default Vue.extend({
    components: { BfButton, BfModal, BfDialog },
    props: {
        dataImportToDelete: { type: Object, required: false, default: () => null },
        currentUser: { type: Object, required: false, default: null }
    },
    data() {
        return {
            autoUpdateOnDelete: true
        };
    },
    methods: {
        deleteFile() {
            this.$emit('delete', this.autoUpdateOnDelete);
            this.autoUpdateOnDelete = true;
        },
        close() {
            this.$emit('close');
            this.autoUpdateOnDelete = true;
        }
    }
});
